.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  height: var(--nav-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--page-padding);
  background: rgba(5, 5, 10, 0.6);
  backdrop-filter: var(--glass-blur);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background var(--duration-medium);
}

.nav[data-scrolled="true"] {
  background: var(--glass-bg);
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  text-decoration: none;
}

.logoIconWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  overflow: hidden;
}

.logoImg {
  /* SVG is 875×801. Icon ends ~y=620; text+tagline live in bottom ~25%. Scale up + shift to show only the icon. */
  width: 100%;
  height: auto;
  transform: translateY(-22%) scale(1.55);
  transform-origin: center top;
  transition: opacity var(--duration-fast);
}

.logo:hover .logoImg {
  opacity: 0.85;
}

.logoText {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 19px;
  color: #fff;
  letter-spacing: -0.01em;
}

.links {
  display: flex;
  gap: 8px;
  align-items: center;
}

.link {
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-pill);
  padding: 8px 20px;
  color: rgba(255, 255, 255, 0.5);
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.35s var(--ease-expo);
  text-decoration: none;
}

.link:hover {
  color: rgba(255, 255, 255, 0.8);
}

.link[data-active="true"] {
  background: var(--link-active-bg);
  border-color: var(--link-active-border);
  color: var(--link-accent);
}

/* ───────────────── CART INDICATOR ───────────────── */

.cartLink {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: 4px;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.35s var(--ease-expo);
}

.cartLink:hover {
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.04);
}

.cartLink[data-active="true"] {
  color: var(--brand-ember);
  border-color: var(--brand-ember-soft);
  background: var(--brand-ember-faint);
}

.cartBadge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: var(--radius-pill);
  background: var(--brand-ember);
  color: var(--brand-paper);
  font-family: var(--font-body);
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

.drawerCartLabel {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.drawerCartBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: var(--radius-pill);
  background: var(--brand-ember);
  color: var(--brand-paper);
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 700;
}

/* ───────────────── REDEEM CTA ───────────────── */

.redeemBtn {
  margin-left: 12px;
  padding: 8px 20px;
  font-family: var(--font-body);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #05050A;
  background: var(--neon-green);
  border: 1px solid var(--neon-green);
  border-radius: var(--radius-pill);
  text-decoration: none;
  cursor: pointer;
  transition: opacity var(--duration-fast), transform 100ms;
  white-space: nowrap;
}

.redeemBtn:hover {
  opacity: 0.88;
}

.redeemBtn:active {
  transform: scale(0.97);
}

.redeemBtn[data-active="true"] {
  background: transparent;
  color: var(--neon-green);
}

/* ───────────────── HAMBURGER TOGGLE ───────────────── */

.menuToggle {
  display: none;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  transition: color var(--duration-fast);
}

.menuToggle:hover {
  color: #fff;
}

/* ───────────────── MOBILE DRAWER ───────────────── */

.drawer {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.drawerBackdrop {
  position: absolute;
  inset: 0;
  background: rgba(5, 5, 10, 0.85);
  backdrop-filter: blur(8px);
}

.drawerContent {
  position: absolute;
  top: 0;
  right: 0;
  width: 280px;
  height: 100%;
  background: var(--color-bg-secondary);
  border-left: 1px solid var(--color-border-default);
  padding: calc(var(--nav-height) + 24px) 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* Six links plus the redeem button need 472px. On a landscape phone the
     panel is 375px tall, and with overflow visible the last link was cut and
     "Got a Code?" sat 97px below the fold, untappable. */
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: none;
}

.drawerContent::-webkit-scrollbar {
  display: none;
}

.drawerLink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  font-family: var(--font-body);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  transition: all 0.3s var(--ease-expo);
  min-height: 44px;
}

.drawerLink:hover {
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.03);
}

.drawerLink[data-active="true"] {
  background: var(--link-active-bg);
  border-color: var(--link-active-border);
  color: var(--link-accent);
}

/* ───────────────── DRAWER REDEEM ───────────────── */

.drawerRedeem {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  padding: 14px 20px;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #05050A;
  background: var(--neon-green);
  text-decoration: none;
  border-radius: var(--radius-md);
  min-height: 48px;
  transition: opacity var(--duration-fast);
}

.drawerRedeem:hover {
  opacity: 0.88;
}

/* ───────────────── RESPONSIVE ───────────────── */

@media (max-width: 768px) {
  .links {
    display: none;
  }

  .cartLink {
    display: none;
  }

  .redeemBtn {
    display: none;
  }

  .menuToggle {
    display: flex;
  }
}
